import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor(public http: HttpClient, public constants: ConstantsService, @Inject(environment.api_host) public api: string) { }

  changes: BehaviorSubject<any> = new BehaviorSubject(false);

  handleError(error: any) {
    console.log('Error received: ' + JSON.stringify(error));
    throw (error);
    return EMPTY;
  }

  get(itemId: string): Observable<any> {
    return this.http.get(this.api + '/' + itemId + environment.api_code)
      .pipe(catchError((e: any) => this.handleError(e)));
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.api + environment.api_code)
      .pipe(catchError((e: any) => this.handleError(e)));
  }

  add(item: any): Observable<any> {
    return this.http.post(this.api + environment.api_code, item)
      .pipe(catchError((e: any) => this.handleError(e)));
  }

  update(item: any) {
    return this.http.put(this.api + '/' + item.id + environment.api_code, item)
      .pipe(catchError((e: any) => this.handleError(e)));
  }

  remove(item: any): Observable<any> {
    return this.http.delete(this.api + '/' + item.id + environment.api_code)
      .pipe(catchError((e: any) => this.handleError(e)));
  }

  encode(query: any): string {
    return btoa(JSON.stringify(query));
  }

  decode(query: string): any {
    return JSON.parse(atob(query));
  }
}